import { render, staticRenderFns } from "./TreeViewHeader.vue?vue&type=template&id=afad6454&"
import script from "./TreeViewHeader.vue?vue&type=script&lang=ts&"
export * from "./TreeViewHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports